import { makeCollectionQuery } from "@web-monorepo/fetchers";

export const useParentStudentsFetcher = makeCollectionQuery({
  fetcherName: "parentStudents",
  path: "/api/parent/{parentId}/student",
  // @ts-expect-error API accepts groupBy but OpenAPI spec omits it from query params
  query: { groupBy: "student" },
});
